import { FaLandmark } from "react-icons/fa"; // Similar to a bridge

export default function Careers() {
  return (
    <section className="py-5 px-3 bg-white">
      <h2 className="text-center text-primary fw-bold display-6">Jobs</h2>
      <div className="mt-4 mx-auto" style={{ maxWidth: "700px" }}>
        {/* Site Engineer Job */}
        <div className="p-4 border rounded shadow-sm bg-light mb-4">
          <h3 className="text-primary fw-semibold">Site Engineer</h3>
          <p className="text-secondary mt-2">
            Looking for experienced professionals for a building construction project at Mahad Taluka, Raigad District, Maharashtra.
          </p>
          <ul className="list-unstyled text-secondary">
            <li><strong>Qualification:</strong> Diploma/B.E. Civil</li>
            <li><strong>Project Type:</strong> Building Construction</li>
            <li><strong>Experience:</strong> 2+ years</li>
            <li><strong>Location:</strong> Mahad Taluka, Raigad District, Maharashtra</li>
            <li><strong>Salary:</strong> Based on experience and industry standards</li>
            <li><strong>Language Preference:</strong> English / Hindi preferred</li>
          </ul>
          <a href="https://forms.gle/YOUR_GOOGLE_FORM_LINK" target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-3">
            Apply Now
          </a>
        </div>

        {/* Project Manager Job */}
        <div className="p-4 border rounded shadow-sm bg-light">
          <h3 className="text-primary fw-semibold">Project Manager</h3>
          <p className="text-secondary mt-2">
            Looking for experienced professionals for a building construction project at Mahad Taluka, Raigad District, Maharashtra.
          </p>
          <ul className="list-unstyled text-secondary">
            <li><strong>Qualification:</strong> Diploma/B.E. Civil</li>
            <li><strong>Project Type:</strong> Building Construction</li>
            <li><strong>Experience:</strong> 5+ years</li>
            <li><strong>Location:</strong> Mahad Taluka, Raigad District, Maharashtra</li>
            <li><strong>Salary:</strong> Based on experience and industry standards</li>
            <li><strong>Language Preference:</strong> English / Hindi preferred</li>
          </ul>
          <a href="https://forms.gle/YOUR_GOOGLE_FORM_LINK" target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-3">
            Apply Now
          </a>
        </div>
      </div>
    </section>
  );
}
